import { createCable } from "@anycable/web";

// Configured via header tag injected in the layout.
// TODO https://github.com/anycable/anycable-client#refreshing-authentication-tokens
export default createCable();
